module.exports = __webpack_public_path__ + "img/melvid-dashboard2.dd3e3753.png";